/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { Row, Button } from 'react-bootstrap';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SelectInput from 'components/input/SelectInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import GroupRadioButtonRounded from 'components/input/GroupRadioButtonRounded';
import { useFormik } from 'formik';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import {
  tryParseJSON,
  optionValues,
  reorder,
  getArrayYears,
} from 'components/helper/helper';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getCollege } from 'app/highSchoolSlice/highSchoolSlice';
import { CollegeCourseDetail, FormCollegeCourse} from 'modal/course';
import { CourseSubjectConfig } from './CourseSubjectConfig';
import { ModalConfirm } from 'screen/common/ModalConfirm';
import { debounce } from 'lodash';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';
//import { authenticateSettings } from 'components/helper/appConfig';
//import Cookies from 'js-cookie';

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

interface Props {
  handleSave: (value: any) => void;
  item: any;
  index: number;
  total: number;
  expandAll?: boolean;
  handleExpandActive: (value: any) => void;
  isMobile?: boolean;
  disabled?: boolean;
}
export const CollegeCourseConfig = (props: Props) => {
  const { isMobile = false, disabled = false  } = props;
  const MAX_COURSES = 9;
  const [termOptions, setTermOptions] = React.useState<any[]>([
    'Fall',
    'Winter',
    'Spring',
    'Summer',
  ]);
  const [yearOptions, setYearOptions] = React.useState<any[]>(
    optionValues(Array.from({ length: 78 }, (_, i) => i + 1950)).reverse()
  );
  const [collegeOptions, setCollegeOptions] = React.useState<any[]>([]);
  const myColleges = useAppSelector((store) => store.highSchool.myCollege);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const query = new URLSearchParams(location.search);
  const check = query.get('check');

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  React.useEffect(() => {
    setExpanded(props.expandAll || false);
  }, [props?.expandAll]);
  
  React.useEffect(() => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      if (!myColleges) {
        dispatch(getCollege(studentId));
      }
      let colleges_taken_coursework_array = tryParseJSON(myColleges?.colleges_taken_coursework_array);

      if (colleges_taken_coursework_array) {
        for (let i = 0; i < colleges_taken_coursework_array.length; i++) {
          let obj = colleges_taken_coursework_array[i];
          if (!obj.fullName) {
            obj.fullName = `${obj?.college_name} (ceeb: ${obj?.college_ceeb}, state: ${obj?.college_state}, city: ${obj?.college_city}, country: ${obj?.college_country})`;
          }
        }
        setCollegeOptions(colleges_taken_coursework_array);
        handlePickCollege(props.item?.collegeName, colleges_taken_coursework_array, { silent: true });
      }
    } else {
      handleLogout();
    }
  }, [myColleges]);
  // dept, collegeCourseSubject, courseName, courseNumber, subject, languageName , creditsPerHours, honorStatus, completionStatus, grade, transferable

  const initialValues: FormCollegeCourse = {
    index: Number(props.item?.index ?? -1),
    lastIndex: null,  
    collegeName: '',
    collegeInformation: null as any,
    scheduleSystem: '',
    academicYear: '',
    term: '',
    academicStatus: '',
    collegeCourseArray: [],
  };

  const formItem = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {},
  });
  const [expanded, setExpanded] = React.useState(props.expandAll || false);
  const isInitialMount = React.useRef(true);
  
  const handleExpandClick = () => {
    setExpanded(!expanded);
    props.handleExpandActive(expanded);
  };

  React.useEffect(() => {
    if (props.item?.collegeName && isInitialMount.current) {
      formItem.setValues({ ...formItem.values, ...props.item });
      isInitialMount.current = false;
      // Reset form dirty state after loading initial data
      formItem.resetForm({ values: { ...formItem.values, ...props.item } });
      // Initialize the previous values ref
      previousFormValuesRef.current = { ...formItem.values, ...props.item };
    } else if (!props.item?.collegeName && isInitialMount.current) {
      // For new items, initialize with empty values and mark as dirty
      const initialValues = {
        ...formItem.values,
        collegeName: '',
        collegeInformation: null,
        scheduleSystem: '',
        academicYear: '',
        term: '',
        academicStatus: '',
        collegeCourseArray: [],
      };
      formItem.setValues(initialValues);
      isInitialMount.current = false;
      // Mark form as dirty for new items so they get saved
      formItem.setFieldTouched('collegeName', true);
      // Initialize the previous values ref
      previousFormValuesRef.current = initialValues;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);



  // Debounced save function to prevent excessive API calls
  const debouncedSave = React.useCallback(
    debounce((values) => {
      props.handleSave(values);
    }, 1000),
    [props.handleSave]
  );

  // Cleanup debounced function on unmount
  React.useEffect(() => {
    return () => {
      debouncedSave.cancel();
    };
  }, [debouncedSave]);

  const [forceRenderKey, setForceRenderKey] = React.useState(0);
  //const previousCourseArrayRef = React.useRef<any[]>([]);
  const previousFormValuesRef = React.useRef<any>({});

  // Enhanced useEffect to track all form changes and trigger auto-save
  React.useEffect(() => {
    if (!isInitialMount.current) {
      // Check if there are any meaningful changes in the form
      const currentValues:string = JSON.stringify(formItem.values) ?? '';
      const previousValues:string = JSON.stringify(previousFormValuesRef.current) ?? '';
      const hasChanged:boolean = currentValues.localeCompare(previousValues) !== 0 ;
      
      // Check if there's meaningful data to save
      const hasMainFieldData = formItem.values.collegeName || 
                              formItem.values.scheduleSystem || 
                              formItem.values.academicYear || 
                              formItem.values.term || 
                              formItem.values.academicStatus;
      
      const hasCourseData = formItem.values.collegeCourseArray?.some((course: any) => 
        course.dept || course.courseNumber || course.courseName || 
        course.collegeCourseSubject || course.grade || course.creditsPerHours ||
        course.subject || course.honorStatus || course.completionStatus
      );

      // Never autosave an empty course list over previously loaded courses (race wipe)
      const previousHadCourses = previousFormValuesRef.current?.collegeCourseArray?.some(
        (course: any) =>
          course.dept ||
          course.courseNumber ||
          course.courseName ||
          course.collegeCourseSubject ||
          course.grade ||
          course.creditsPerHours
      );
      if (previousHadCourses && !hasCourseData) {
        // Keep previousFormValuesRef pointing at the last good snapshot
        return;
      }
      
      // Trigger save if there are changes and meaningful data
      if (formItem.dirty || (hasChanged && (hasMainFieldData || hasCourseData))) {
        debouncedSave({
          ...formItem.values,
        });
      }
      
      // Update the ref with current values
      previousFormValuesRef.current = JSON.parse(currentValues);
    }
  }, [formItem.values, debouncedSave]);

  // Remove the old useEffect that was only tracking collegeCourseArray
  // The new useEffect above handles all form changes

  // Remove the old useEffect that was trying to mark form as dirty
  // The new approach doesn't rely on formik's dirty state

  const renderTitle = () => {
    const values: string[] = [];
    formItem.values.collegeName?.length && values.push(formItem.values.collegeName);
    formItem.values.term?.length && values.push(formItem.values.term);
    formItem.values.academicYear && values.push(formItem.values.academicYear);
    return <span className="p-1">{values.join(' - ')}</span>;
  };

  // ModalConfirm state for course subject removal
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [removeIndex, setRemoveIndex] = React.useState<number | null>(null);
  
  const handleClose = () => {
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  
  const handleConfirm = (index: number) => {
    const newData = [...formItem.values.collegeCourseArray];
    newData.splice(index, 1);
    formItem.setFieldValue('collegeCourseArray', newData);
    // Ensure the form is marked as touched to trigger auto-save
    formItem.setFieldTouched('collegeCourseArray', true);
    setOpenConfirm(false);
    setRemoveIndex(null);
  };

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    let lsData: CollegeCourseDetail[] = [];
    if (formItem.values.collegeCourseArray && formItem.values.collegeCourseArray.length > 0) {
      lsData = formItem.values.collegeCourseArray.map((e: CollegeCourseDetail, i: number) => {
        return { ...e, index: i + 1, lastIndex: i + 1 };
      });
    }

    const dataList = reorder(lsData, result.source.index, result.destination.index);

    formItem.setFieldValue('collegeCourseArray', [...dataList]);
    // Ensure the form is marked as touched to trigger auto-save
    formItem.setFieldTouched('collegeCourseArray', true);
    setForceRenderKey(forceRenderKey + 1);
  };

  const handleAddCourse = () => {
    if (formItem.values.collegeCourseArray.length > MAX_COURSES - 1) return;
    const newCourseArray = [
      ...formItem.values.collegeCourseArray,
      {
        dept: '',
        collegeCourseSubject: '',
        courseName: '',
        courseNumber: '',
        subject: '',
        languageName: '',
        creditsPerHours: '',
        grade: '--',
        honorStatus: '--',
        completionStatus: 'Select',
        transferable: false,
      },
    ];
    formItem.setFieldValue('collegeCourseArray', newCourseArray);
    // Ensure the form is marked as touched to trigger auto-save
    formItem.setFieldTouched('collegeCourseArray', true);
  };

  const handlePickCollege = (collegeName: string, collegeDate: any[], opts?: { silent?: boolean }) => {
    if (!collegeName) {
      formItem.setFieldValue('collegeInformation', null);
      return;
    }

    let collegeInformation = collegeDate.find((item) => item.fullName === collegeName);
    if (collegeInformation === undefined) {
      collegeInformation = collegeDate.find((item) => item.college_name === collegeName);
    }
    if (collegeInformation === undefined) {
      collegeInformation = collegeDate.find(
        (item) => item.college_info?.college_name === collegeName
      );
    }
    if (collegeInformation === undefined) {
      collegeInformation = collegeDate.find((item) => item.school?.name === collegeName);
    }

    const years = getArrayYears(collegeInformation?.fromDate, collegeInformation?.toDate);
    formItem.setFieldValue('collegeInformation', collegeInformation ?? null);
    // Syncing college metadata must not mark the form dirty / trigger autosave
    if (!opts?.silent) {
      formItem.setFieldTouched('collegeInformation', true);
    }
    if (years.length > 0) {
      setYearOptions(years);
    }
  };
  
  return (
    <div className="m-0">
      <Card className="w-100 my-3 px-0">
        <CardActions
          id={`collegeItem${props.index}`}
          aria-expanded={expanded}
          disableSpacing
          onClick={handleExpandClick}
          sx={{
            backgroundColor: expanded ? '#AAEBF7' : 'none',
            borderBottom: expanded ? '2px solid #4D88F0' : 'none',
          }}
        >
          <div className="w-100 d-flex justify-content-between">
            <span className="p-1">{renderTitle()}</span>
            <strong className="text-field-light">
              {props.index}/{props.total}
            </strong>
          </div>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Row className="px-3">
              <SelectInput
                id={`collegeName_${props.index}`}
                option={collegeOptions.map((i) => {
                  return { name: i.fullName, value: i.college_name };
                })}
                mdCol="12"
                name="collegeName"
                label="College"
                values={formItem.values.collegeName}
                onChange={(e: any) => {
                  formItem.handleChange(e);
                  formItem.setFieldTouched('collegeName', true);
                  handlePickCollege(e.target.value, collegeOptions);
                }}
                isMissing={!formItem.values.collegeName && check ? true : false}
                disabled={disabled}
              />
              <SelectInput
                id={`academicYear_${props.index}`}
                className="coallition-flag"
                form={formItem}
                option={yearOptions}
                label="Academic year *"
                values={formItem.values.academicYear}
                name="academicYear"
                onChange={(e: any) => {
                  formItem.handleChange(e);
                  formItem.setFieldTouched('academicYear', true);
                  let options = [];
                  const collegeInformation = collegeOptions.find(
                    (item) => item.fullName === formItem.values.collegeName
                  );
                  if (collegeInformation) {
                    if (collegeInformation.grades_spring.includes(e.target.value)) {
                      options.push('Spring');
                    }

                    if (collegeInformation.grades_summer.includes(e.target.value)) {
                      options.push('Summer');
                    }
                    if (collegeInformation.grades_fall.includes(e.target.value)) {
                      options.push('Fall');
                    }
                    if (collegeInformation.grades_winter.includes(e.target.value)) {
                      options.push('Winter');
                    }
                  }
                  // setTermOptions(options);
                }}
                isMissing={!formItem.values.academicYear && check ? true : false}
                disabled={disabled}
              />
              <SelectInput
                id={`academicStatus_${props.index}`}
                form={formItem}
                option={[
                  { name: '- Select -', value: '' },
                  { name: 'Freshman', value: 'Freshman' },
                  { name: 'Sophomore', value: 'Sophomore' },
                  { name: 'Junior', value: 'Junior' },
                  { name: 'Senior', value: 'Senior' },
                  { name: 'Graduate', value: 'Graduate' },
                  { name: 'Post-Baccalaureate', value: 'Post-Baccalaureate' },
                ]}
                label="College Academic Status"
                values={formItem.values.academicStatus}
                name="academicStatus"
                onChange={(e: any) => {
                  formItem.handleChange(e);
                  formItem.setFieldTouched('academicStatus', true);
                }}
                isMissing={!formItem.values.academicStatus && check ? true : false}
                disabled={disabled}
              />
              <div />
              <GroupRadioButtonRounded
                id={`scheduleSystem_${props.index}`}
                label="Schedule System *"
                className="py-4"
                mdCol={2}
                options={[{ value: 'Semester' }, { value: 'Quarter' }]}
                name="scheduleSystem"
                values={formItem.values.scheduleSystem}
                onChange={(e: any) => {
                  formItem.handleChange(e);
                  formItem.setFieldTouched('scheduleSystem', true);
                }}
                isMissing={!formItem.values.scheduleSystem && check ? true : false}
                disabled={disabled}
              />

              <GroupRadioButton
                columns={4}
                id={`term_${props.index}`}
                options={termOptions}
                label="Term *"
                values={formItem.values.term}
                name="term"
                onChange={(e: any) => {
                  formItem.handleChange(e);
                  formItem.setFieldTouched('term', true);
                }}
                isMissing={!formItem.values.term && check ? true : false}
                disabled={disabled}
              />
              <div />

              <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
                <Droppable droppableId="list">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {(formItem.values.collegeCourseArray ?? []).map((item, index) => (
                        <div key={index + '-' + formItem.values.collegeCourseArray.length}>
                          <Draggable
                            draggableId={index + '-' + formItem.values.collegeCourseArray.length}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div
                                  key={index + '-' + formItem.values.collegeCourseArray.length}
                                  className="position-relative"
                                >
                                  <CourseSubjectConfig
                                    courseIndex={props.index}
                                    form={formItem}
                                    i={index}
                                    total={formItem.values.collegeCourseArray?.length??0}
                                    disabled={disabled}
                                  />
                                  <RemoveCircleOutlineIcon
                                    className="position-absolute text-field-light pointer"
                                    style={{ right: '-24px', top: '12px', opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                                    onClick={() => {
                                      if (disabled) return;
                                      setRemoveIndex(index);
                                      setOpenConfirm(true);
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </Draggable>
                        </div>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              <div className="my-3 w-100 d-flex flex-column align-items-center">
                <div className="text-field-light sized70">{`You can add up to ${MAX_COURSES} courses per term`}</div>
                <Button variant="primary" className="p-2 px-5" onClick={handleAddCourse} disabled={disabled}>
                  Add Subject
                </Button>
              </div>
            </Row>
          </CardContent>
        </Collapse>
      </Card>
      <ModalConfirm 
        open={openConfirm}
        handleClose={handleClose} 
        handleConfirm={() => {
          if (removeIndex !== null) handleConfirm(removeIndex);
        }}
        title=""
        message="Are you sure you want to remove this college course?"
        confirmText="Remove"
        cancelText="Cancel"
      />
    </div>
  );
};

export default CollegeCourseConfig;
